import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import {RouterLinks} from '@core/constants/routes.constants';
import {DashboardPaths} from '@core/enums/dashboard-paths.enum';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard  {
  constructor(
    private router: Router,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): boolean {
    const originalRequestUrl = state.url;
    const firstRoute = this.getFirstPath(originalRequestUrl);
    const isDashboard = this.isDashboardRoute(firstRoute);

    if (isDashboard) {
      this.redirectToDashboard(originalRequestUrl);
    } else {
      this.router.navigate(['not-found']);
    }

    return true;
  }

  private getFirstPath(url: string): string {
    const urlWithoutSlash = url.substring(1);
    const nextSlashIndex = urlWithoutSlash.indexOf('/');
    if (nextSlashIndex !== -1) {
      return urlWithoutSlash.substring(0, nextSlashIndex);
    }
    return urlWithoutSlash;
  }

  private isDashboardRoute(url: string): boolean {
    const paths: string[] = Object.values(DashboardPaths);

    return paths.includes(url);
  }

  private redirectToDashboard(url: string): void {
    const fixedUrl = `${RouterLinks.DASHBOARD}${url}`;
    this.router.navigate([fixedUrl]);
  }
}
